import {gql} from 'apollo-boost';
import {LibraryPlaylistComplete} from '../../../../../../graphql/LibraryPlaylistCompleteFragment';

export const LIBRARY_PLAYLISTS_QUERY = gql`
  query LibraryPlaylistsQuery($limit: Int, $offset: Int) {
    me {
      id
      library {
        playlists(limit: $limit, offset: $offset) {
          ...LibraryPlaylistComplete
        }
      }
    }
  }
  ${LibraryPlaylistComplete.libraryPlaylist}
`;
